import React from 'react';

import {
  LIST_YOUR_PLACE,
  APOLLO_SUPPLY_LANDING,
  SEARCH,
} from 'ha/constants/pageNames';
import { Language, IntlObject } from 'ha/i18n/types';
import { notEmpty } from 'ha/utils/notEmpty';

import BookIcon from 'streamline-icons/book-open-text-bold.svg';
import FAQIcon from 'streamline-icons/messages-bubble-square-question-alternate-bold.svg';
import HelpIcon from 'streamline-icons/help-wheel-bold.svg';

const CTA_BLACK_LIST = [LIST_YOUR_PLACE, APOLLO_SUPPLY_LANDING, SEARCH];

export const checkIfCTAVisible = (pageName: string, pageCategory?: string) =>
  !(
    CTA_BLACK_LIST.includes(pageName) ||
    CTA_BLACK_LIST.includes(pageCategory || '')
  );

interface Link {
  icon: React.ReactElement;
  title: string;
  caption: string;
  url: string;
  noFollow: boolean;
}

export const getLearnMenuLinks = (intl: IntlObject) => {
  const { lang, urlResolver, T } = intl;

  const hasCommunityUrl = urlResolver.hasCommunityUrl(lang);

  const tenantLinks: Link[] = [
    {
      icon: <BookIcon color="secondary" fontSize="inherit" />,
      title: T('navbar_learn_tenant_blog_title'),
      caption: T('navbar_learn_tenant_blog_caption'),
      url: hasCommunityUrl
        ? urlResolver.getCommunityUrl(lang)
        : urlResolver.getCommunityUrl(Language.en),
      noFollow: !hasCommunityUrl,
    },
    {
      icon: <FAQIcon color="secondary" fontSize="inherit" />,
      title: T('navbar_learn_tenant_faq_title'),
      caption: T('navbar_learn_tenant_faq_caption'),
      url: 'https://answers.housinganywhere.com/en/collections/1445947-tenants',
      noFollow: lang !== Language.en,
    },
  ];

  const hasLandlordsCommunityUrl = urlResolver.hasLandlordsCommunityUrl(lang);
  const hasHelpCenterUrl = urlResolver.hasHelpCenterUrl(lang);

  const landlordLinks: Link[] = [
    hasLandlordsCommunityUrl
      ? {
          icon: <BookIcon color="mint" fontSize="inherit" />,
          title: T('navbar_learn_landlord_blog_title'),
          caption: T('navbar_learn_landlord_blog_caption'),
          url: urlResolver.getLandlordsCommunityUrl(lang),
          noFollow: false,
        }
      : undefined,
    {
      icon: <HelpIcon color="mint" fontSize="inherit" />,
      title: T('navbar_learn_landlord_help_title'),
      caption: T('navbar_learn_landlord_help_caption'),
      url: hasHelpCenterUrl
        ? urlResolver.getHelpCenterUrl(lang)
        : urlResolver.getHelpCenterUrl(Language.en),
      noFollow: !hasHelpCenterUrl,
    },
    {
      icon: <FAQIcon color="mint" fontSize="inherit" />,
      title: T('navbar_learn_landlord_faq_title'),
      caption: T('navbar_learn_landlord_faq_caption'),
      url:
        'https://answers.housinganywhere.com/en/collections/1445961-advertisers',
      noFollow: lang !== Language.en,
    },
  ].filter(notEmpty);

  return {
    tenant: tenantLinks,
    landlord: landlordLinks,
  };
};
